<style lang="less">
.area-contrast-container {
  width: 750px;
  height: 100%;
  background: #f7f7f7;
  #contrast_map {
    width: 100%;
    height: 320px;
  }
  .contrast-main {
    width: 718px;
    padding: 0 16px;
    background: #f7f7f7;
    .area-score {
      background: #fff;
      box-shadow: 0px 0px 8px 0px rgba(219, 219, 219, 0.5);
      border-radius: 6px;
      .area-score-top {
        padding: 24px 24px 0;
        .area-score-info {
          margin-bottom: 18px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .area-score-info-left {
            // margin-left: 98px;
            .area-item {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              margin-top: 40px;
              position: relative;
              .area-itrm-quan {
                position: absolute;
                left: 0;
                top:40%;
                width: 14px;
                height: 14px;
                border-radius: 14px;
              }
              span{
                margin-left: 34px;
                font-size:26px;
                color:rgba(35,44,55,1);
              }
            }
          }
          .area-score-info-right {
            width: 350px;
            height: 300px;
            .charts-bar {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .area-score-bottom {
      }
    }
    .market-performance {
      padding: 24px;
      .charts-radar {
        width: 100%;
        height: 500px;
      }
    }
    .rent-trend {
      padding: 24px;
      .rent-trend-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .selsec-rent-type {
          display: flex;
          justify-content: center;
          align-items: center;
          li {
            margin-left: 64px;
            font-size: 26px;
            color: rgba(137, 147, 159, 1);
          }
          .selected {
            color: #4169e1;
          }
        }
      }
      .contrast-line {
        width: 100%;
        height: 350px;
        margin-top: 48px;
      }
    }
  }
  .main-style {
    background: #fff;
    box-shadow: 0px 0px 8px 0px rgba(219, 219, 219, 0.5);
    border-radius: 6px;
    margin-top: 18px;
  }
  .table-title-style {
    padding: 24px 24px 14px;
  }
  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(35, 44, 55, 1);
    line-height: 44px;
    text-align: left;
  }
  table {
    width: 100%;
    th,
    td {
      border: 2px solid #eeeeee;
      border-left: none;
      border-bottom: none;
      padding: 16px 0 16px 22px;
      text-align: left;
      font-size: 24px;
      color: rgba(35, 44, 55, 1);
    }
    .no-border {
      border-right: none;
    }
    .table-header {
      font-weight: 600;
    }
    .table-header-one {
      color: rgba(137, 147, 159, 1);
    }
  }
  .footer{
    height:36px;
    font-size:26px;
    color:rgba(189,195,206,1);
    line-height:36px;
    margin: 32px 0 34px;
  }
  .no-contrast{
    background: #F7F7F7;
    width: 100%;
    height: 100%;
    padding-top: 16px;
    .content{
      background: #fff;
      padding-top: 110px;
      .desc{
        height:40px;
        font-size:28px;
        color:rgba(111,120,132,1);
        line-height:40px;
      }
      .return-last{
        width:340px;
        height:88px;
        background:rgba(65,105,225,1);
        border-radius:5px;
        color: #fff;
        border: none;
        margin-top: 80px;
      }
    }
  }
}
</style>
<template>
    <div class="area-contrast-container">
      <div v-if="!noContrast">
        <div id="contrast_map"></div>
        <div class="contrast-main">
            <div class="area-score">
                <div class="area-score-top">
                    <div class="title">商圈评分</div>
                    <div class="area-score-info">
                        <div class="area-score-info-left">
                            <ul>
                                <li
                                    class="area-item"
                                    v-for="(item,index) in scoreList"
                                    :key="index"
                                >
                                    <div
                                        class="area-itrm-quan"
                                        :style="index==0?'backgroundColor:#698EFF':index==1?'backgroundColor:#4ACAA8':'backgroundColor:#F5A623'"
                                    ></div>
                                    <span>{{item.name}}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="area-score-info-right" v-if="scoreList.length>0">
                            <Bar class="charts-bar" :yData="scoreList"></Bar>
                        </div>
                    </div>
                </div>
                <div class="area-score-bottom">
                    <table cellspacing="0">
                        <thead>
                            <tr>
                                <th class="table-header-one">对比项</th>
                                <th
                                    class="table-header"
                                    v-for="(item,index) in compareList"
                                    :key="index"
                                    :class="index==2?'no-border':''"
                                >{{item.name}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="table-header">月租金</td>
                                <td
                                    v-for="(item,index) in compareList"
                                    :key="index"
                                    :class="index==2?'no-border':''"
                                >{{item.unitRentPrice}}元/㎡</td>
                            </tr>
                            <tr>
                                <td class="table-header">挂牌量</td>
                                <td
                                    v-for="(item,index) in compareList"
                                    :key="index"
                                    :class="index==2?'no-border':''"
                                >{{item.houseNum}}</td>
                            </tr>
                            <tr>
                                <td class="table-header">挂牌周期</td>
                                <td
                                    v-for="(item,index) in compareList"
                                    :key="index"
                                    :class="index==2?'no-border':''"
                                >{{item.activeDate}}天</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="market-performance main-style">
                <div class="title">市场表现</div>
                <Radar class="charts-radar" id="contrast-radar" v-if="marketPerformanceInfo.length>0" :areaData="marketPerformanceInfo"></Radar>
            </div>
            <div class="rent-trend main-style">
                <div class="rent-trend-header">
                    <div class="title">租金走势</div>
                    <ul class="selsec-rent-type">
                        <li
                            v-for="(item,index) in rentList"
                            :key="index"
                            :class="selectRentType==index?'selected':''"
                             @click="selectRentingType(index)"
                        >{{item}}</li>
                    </ul>
                </div>
                <div ref="contrast-line" class="contrast-line"></div>
            </div>
            <div class="business-district-matching main-style">
                <div class="table-title-style">
                    <div class="title">商圈配套</div>
                </div>
                <table cellspacing="0">
                    <thead>
                        <tr>
                            <th class="table-header-one">对比项</th>
                            <th
                                class="table-header"
                                v-for="(item,index) in supportList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.zoneName}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="table-header">地铁站</td>
                            <td
                                v-for="(item,index) in supportList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.subwayCount}}</td>
                        </tr>
                        <tr>
                            <td class="table-header">公交站</td>
                            <td
                                v-for="(item,index) in supportList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.busCount}}</td>
                        </tr>
                        <tr>
                            <td class="table-header">超市</td>
                            <td
                                v-for="(item,index) in supportList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.supermarketCount}}</td>
                        </tr>
                        <tr>
                            <td class="table-header">商场</td>
                            <td
                                v-for="(item,index) in supportList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.mallCount}}</td>
                        </tr>
                        <tr>
                            <td class="table-header">餐饮</td>
                            <td
                                v-for="(item,index) in supportList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.restaurantCount}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="cell-information main-style">
                <div class="table-title-style">
                    <div class="title">小区信息</div>
                </div>
                <table cellspacing="0">
                    <thead>
                        <tr>
                            <th class="table-header-one">对比项</th>
                            <th
                                class="table-header"
                                v-for="(item,index) in cellInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.name}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="table-header">小区总数</td>
                            <td
                                v-for="(item,index) in cellInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.totalNum}}</td>
                        </tr>
                        <tr>
                            <td class="table-header">近地铁</td>
                            <td
                                v-for="(item,index) in cellInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.nearSubwayNum}}</td>
                        </tr>
                        <!-- <tr>
                            <td class="table-header">近半年新小区</td>
                            <td
                                v-for="(item,index) in cellInfoList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.newNum}}</td>
                        </tr> -->
                    </tbody>
                </table>
            </div>
            <div class="company-information main-style">
                <div class="table-title-style">
                    <div class="title">企业信息</div>
                </div>
                <table cellspacing="0">
                    <thead>
                        <tr>
                            <th class="table-header-one">对比项</th>
                            <th
                                class="table-header"
                                v-for="(item,index) in enterpriseList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.name}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="table-header">企业数量</td>
                            <td
                                v-for="(item,index) in enterpriseList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.enterpriseNum}}</td>
                        </tr>
                        <tr>
                            <td class="table-header">在招岗位</td>
                            <td
                                v-for="(item,index) in enterpriseList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.employeeNum}}</td>
                        </tr>
                        <tr>
                            <td class="table-header">平均工资</td>
                            <td
                                v-for="(item,index) in enterpriseList"
                                :key="index"
                                :class="index==2?'no-border':''"
                            >{{item.averagePay}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
      </div>
      <div class="no-contrast" v-if="noContrast">
        <div class="content">
            <div class="desc">没有添加商圈哦～</div>
            <button class="return-last" @click="returnLast">返回上一页</button>
          </div>
      </div>
    </div>
</template>

<script>
var map;
let timestampStart,timestampEnd;
import { Progress, Dialog, Popup, Toast } from "vant";
import Bar from "@/components/echarts_bar-radius";
import Radar from "@/components/echarts_radar";
export default {
  name: "contrast",
  components: {
    Progress,
    Bar,
    Radar,
    "van-popup": Popup
  },
  data() {
    return {
      cityId: 30,
      noOpenDeatil: true,
      scoreList: [],
      rentList: ["整租", "合租"],
      selectRentType: 0,
      contrastArr:[],
      areaContrastArr:[],
      compareList:[],
      supportList:[],
      cellInfoList:[],
      enterpriseList:[],
      rentTrend:[],
      marketPerformanceInfo:[],
      noContrast:false
    };
  },
  directives: {
    debounce: {
      inserted: function(el, binding) {
        let timer;
        el.addEventListener("click", () => {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            binding.value();
          }, 500);
        });
      }
    }
  },
  created() {
    timestampStart = (new Date()).getTime();
    this.addBuried({
      source:'1',
      eventType: '曝光事件',
      eventContent: '商圈对比'
    });
    let options = this.$route.query;
    this.cityId = options.cityId;
    this.contrastArr = JSON.parse(localStorage.getItem('contrastArr'));
    if (!this.contrastArr||this.contrastArr.length<1) {
      this.noContrast = true;
      return false
    }
    this.getZoneCompare();
    this.getSupportInfo();
    this.getCellInfo();
    this.getEnterprise();
    this.getRentTrend(1);
    this.getMarketPerformance();
  },
  mounted() {
    this.onReachBottom(e=>{
      this.addBuried({
        source:'1',
        eventType: '触底事件',
        eventContent: '商圈对比'
      });
    });
    map = new BMap.Map("contrast_map");
    var point = new BMap.Point(116.404, 39.915);
    map.centerAndZoom(point, 12);
    // map.disableDragging();
    map.disableDoubleClickZoom();
    map.disableScrollWheelZoom();
    map.disablePinchToZoom();
    this.getPointScore();
    map.addEventListener("touchmove", e => {
      this.noOpenDeatil = false;
      map.enableDragging();
    });
    map.addEventListener("touchend", e => {
      this.noOpenDeatil = true;
      map.disableDragging();
    });
  },
  methods: {
    returnLast(){
      this.isMiniProgram(res => {
        if (res) {
          wx.miniProgram.navigateBack({
            delta: 1
          });
        } else {
          this.$router.go(-1);
        }
      });
    },
    getPointScore() {
      const toast1 = Toast.loading({
        duration: 300, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner"
      });
      let self = this;
      let param;
      param = {
        type:1,
        ids:this.contrastArr.length==3?this.contrastArr[0] +','+ this.contrastArr[1] +','+ this.contrastArr[2]:this.contrastArr.length==2?this.contrastArr[0] +','+ this.contrastArr[1]:this.contrastArr[0]
      };
      this.$axios
        .post("api/xz/compare/score/", param)
        .then(res => {
          if (res.success) {
            let open = true;
            let mp = map;
            //定义自定义覆盖物的构造函数
            //1、定义构造函数并继承Overlay
            function ComplexCustomOverlay(point, title, score) {
              this._point = point;
              this._title = title;
              this._score = score;
            } // 继承API的BMap.Overlay
            ComplexCustomOverlay.prototype = new BMap.Overlay();
            //2、初始化自定义覆盖物
            // 实现初始化方法
            ComplexCustomOverlay.prototype.initialize = function(map) {
              // this.se = false;//禁止清除marker
              // 保存map对象实例
              this._map = map;
              // 创建div元素，作为自定义覆盖物的容器
              var div = (this._div = document.createElement("div"));
              div.style.position = "absolute";
              // div.style.zIndex = BMap.Overlay.getZIndex(this._point.latitude);//聚合功能?
              // 可以根据参数设置元素外观
              var arrow = (this._arrow = document.createElement("img"));
              let img = require("../../assets/img/score_bg.png");
              // "http://img-set.oss-cn-beijing.aliyuncs.com/score?Expires=1554292145&OSSAccessKeyId=TMP.AQEuNork9JZT4SzPmx7q4OC9WbgrDekvEkhlIB83fwneKk9WbJ-_j6fTXKvFAAAwLAIUS0LsBtOGKADVwGQXkk9u15q0TD8CFGJL9Qeum-3LNzVnU4gsbkRn7iuG&Signature=UI8rDap3xUZcE4Nr97CdDJrX6fY%3D";
              arrow.src = img;
              arrow.style.width = "60px";
              arrow.style.height = "65px";
              div.appendChild(arrow);
              var div1 = (this._div1 = document.createElement("div"));
              div1.style.color = "#fff";
              div1.style.fontSize = "13px";
              div1.style.textAlign = "center";
              div1.style.width = "60px";
              div1.style.position = "absolute";
              div1.style.left = "0";
              if (this._title.length > 4) {
                div1.style.top = "5px";
                div1.innerHTML = this._title.slice(0, 3);
                div.appendChild(div1);
                var div3 = (this._div3 = document.createElement("div"));
                div3.style.color = "#fff";
                div3.style.fontSize = "13px";
                div3.style.textAlign = "center";
                div3.style.width = "60px";
                div3.style.position = "absolute";
                div3.style.top = "20px";
                div3.style.left = "0";
                div3.innerHTML = this._title.slice(3, this._title.length);
                div.appendChild(div3);
              } else {
                div1.style.top = "12px";
                div1.innerHTML = this._title;
                div.appendChild(div1);
              }
              var div2 = (this._div2 = document.createElement("div"));
              div2.style.color = "#fff";
              div2.style.fontSize = "13px";
              div2.style.textAlign = "center";
              div2.style.width = "60px";
              div2.style.fontWeight = "bold";
              div2.style.position = "absolute";
              if (this._title.length > 4) {
                div2.style.top = "35px";
              } else {
                div2.style.top = "28px";
              }
              div2.style.left = "0";
              div2.innerHTML = this._score + "分";
              div.appendChild(div2); // 将div添加到覆盖物容器中
              var div3 = (this._div3 = document.createElement("img"));
              div3.src = require('../../assets/img/area_close.png');
              div3.style.width = "15px";
              div3.style.height = "15px";
              div3.style.position = "absolute";
              div3.style.top = "0px";
              div3.style.right = "0px";
              div.appendChild(div3);

              mp.getPanes().labelPane.appendChild(div); //getPanes(),返回值:MapPane,返回地图覆盖物容器列表  labelPane呢???
              // 需要将div元素作为方法的返回值，当调用该覆盖物的show、
              // hide方法，或者对覆盖物进行移除时，API都将操作此元素。
              return div;
            };
            //3、绘制覆盖物
            // 实现绘制方法
            ComplexCustomOverlay.prototype.draw = function() {
              var map = this._map;
              var pixel = map.pointToOverlayPixel(this._point);
              this._div.style.left = pixel.x + "px";
              this._div.style.top = pixel.y - 30 + "px";
            };
            //4、自定义覆盖物添加事件方法
            ComplexCustomOverlay.prototype.addEventListener = function(
              event,
              fun
            ) {
              this._div["on" + event] = fun;
            };
            let scoreList =  res.result;
            self.scoreList = scoreList;
            let scoreLen = scoreList.length;
            let pointArr = [];
            for (let i = 0; i < scoreLen; i++) {
              var myCompOverlay = new ComplexCustomOverlay(
                new BMap.Point(scoreList[i].longitude, scoreList[i].latitude),
                scoreList[i].name,
                scoreList[i].value
              );
              mp.addOverlay(myCompOverlay); //将标注添加到地图中
              pointArr.push(
                new BMap.Point(scoreList[i].longitude, scoreList[i].latitude)
              );
              toast1.clear();
              myCompOverlay._div3.addEventListener("touchend", () => {
                if (!self.noOpenDeatil) {
                  return false;
                }
                mp.addEventListener("click", function(e) {
                  self.addBuried({
                    source: "1",
                    eventType: "点击事件",
                    eventContent: "删除对比商圈"
                  });
                  let overlaysArr = mp.getOverlays();
                  for (let j = 0; j < overlaysArr.length; j++) {
                    if (overlaysArr[j]._title == scoreList[i].name) {
                      mp.removeOverlay(overlaysArr[j]);
                      let contrastArr = JSON.parse(localStorage.getItem('contrastArr'));
                      for (let n = 0; n < contrastArr.length; n++) {
                        if (contrastArr[n] == scoreList[i].id) {
                          contrastArr.splice(n,1)
                        }
                      }
                      localStorage.setItem('contrastArr',JSON.stringify(contrastArr));
                      self.contrastArr = contrastArr;
                      if (!self.contrastArr||self.contrastArr.length<1) {
                        self.noContrast = true;
                        return false;
                      }
                      self.getPointScore();
                      self.getZoneCompare();
                      self.getSupportInfo();
                      self.getCellInfo();
                      self.getEnterprise();
                      self.getRentTrend(1);
                      self.getMarketPerformance();
                    }
                  }
                });
              });
            }
            map.setViewport(pointArr);
          }
        })
        .catch(err => {
          toast1.clear();
          console.log(err);
        });
    },
    //获取商圈对比项
    getZoneCompare(){
      this.$axios
        .post("api/xz/compare/zone/", {
          ids:this.contrastArr.length==3?this.contrastArr[0] +','+ this.contrastArr[1] +','+ this.contrastArr[2]:this.contrastArr.length==2?this.contrastArr[0] +','+ this.contrastArr[1]:this.contrastArr[0]
        })
        .then(res => {
          if (res.success) {
            this.compareList = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取商圈配套
    getSupportInfo(){
      this.$axios
        .post("api/xz/compare/support/", {
          ids:this.contrastArr.length==3?this.contrastArr[0] +','+ this.contrastArr[1] +','+ this.contrastArr[2]:this.contrastArr.length==2?this.contrastArr[0] +','+ this.contrastArr[1]:this.contrastArr[0]
        })
        .then(res => {
          if (res.success) {
            this.supportList = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取商圈小区信息
    getCellInfo(){
      this.$axios
        .post("api/xz/compare/community/type/", {
          ids:this.contrastArr.length==3?this.contrastArr[0] +','+ this.contrastArr[1] +','+ this.contrastArr[2]:this.contrastArr.length==2?this.contrastArr[0] +','+ this.contrastArr[1]:this.contrastArr[0]
        })
        .then(res => {
          if (res.success) {
            this.cellInfoList = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取商圈企业信息
    getEnterprise(){
      this.$axios
        .post("api/xz/compare/enterprise/", {
          ids:this.contrastArr.length==3?this.contrastArr[0] +','+ this.contrastArr[1] +','+ this.contrastArr[2]:this.contrastArr.length==2?this.contrastArr[0] +','+ this.contrastArr[1]:this.contrastArr[0]
        })
        .then(res => {
          if (res.success) {
            this.enterpriseList = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //选择在租类型
    selectRentingType(e){
      this.selectRentType = e;
      this.getRentTrend(e+1)
    },
    //获取租金走势信息
    getRentTrend(rentType){
      this.$axios
        .post("api/xz/compare/rent/trend/", {
          ids:this.contrastArr.length==3?this.contrastArr[0] +','+ this.contrastArr[1] +','+ this.contrastArr[2]:this.contrastArr.length==2?this.contrastArr[0] +','+ this.contrastArr[1]:this.contrastArr[0],
          rentType:rentType,
          cityId:this.cityId
        })
        .then(res => {
          if (res.success) {
            this.rentTrend = res.result;
            this.createLine();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取市场表现信息
    getMarketPerformance(){
      this.$axios
        .post("api/xz/compare/market/", {
          ids:this.contrastArr.length==3?this.contrastArr[0] +','+ this.contrastArr[1] +','+ this.contrastArr[2]:this.contrastArr.length==2?this.contrastArr[0] +','+ this.contrastArr[1]:this.contrastArr[0]
        })
        .then(res => {
          if (res.success) {
            this.marketPerformanceInfo = res.result;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //创建line图表
    createLine() {
      let dom = this.$refs["contrast-line"];
      let myChart = this.$echarts.init(dom);
      var timestamp = Date.parse(new Date());
      var date = new Date(timestamp);
      //获取年份
      var Y = date.getFullYear();
      //获取月份
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var currentMonth = Y + "-" + M;
      let self = this;

      function getNewDate(_dateObject, x) {
        if (
          _dateObject == null ||
          undefined == _dateObject ||
          _dateObject == ""
        ) {
          _dateObject = new Date();
        }
        _dateObject.setMonth(_dateObject.getMonth() + x);

        //返回日期的毫秒表示
        var nd = _dateObject.valueOf();
        nd = new Date(nd);

        var y = nd.getFullYear();
        var m = nd.getMonth() + 1;
        var d = nd.getDate();

        if (m <= 9) m = "0" + m;
        if (d <= 9) d = "0" + d;
        var cdate = y + "-" + m;

        return cdate;
      }
      let pastSixDate = getNewDate(date, -5);
      function getMonth(num) {
        let date1 = new Date(self.addMonth(date, num));
        let year = date1.getFullYear();
        let month = date1.getMonth() + 1;
        return year + "-" + (month < 10 ? "0" + month : month);
      }
      let pastSix = [
        pastSixDate,
        getMonth(1),
        getMonth(2),
        getMonth(3),
        getMonth(4),
        getMonth(5)
      ];
      let option = '';
      let lineHeight = this.$refs["contrast-line"].clientHeight;
      let lineWidth = this.$refs["contrast-line"].clientWidth;
      let seriesList = [];
      let rentTrendList = this.rentTrend.data;
      for (let i = 0; i < rentTrendList.length; i++) {
        seriesList.push({
          name: rentTrendList[i].name,
          type: "line",
          smooth: true,
          data: rentTrendList[i].value
        })
      }
      option = {
        title: {
          show: false
        },
        grid: {
          top: "5%",
          left: "13%",
          right: "10%",
          bottom: "10%",
          containLabel: false,
          height: lineHeight * 0.7,
          width: lineWidth * 0.85
        },
        color: ["#4169E1", "#4ACAA8", "#F5A623"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              type: "dashed"
            }
          },
          // formatter:'{b0}<br />整租: {c0}元/㎡<br />合租: {c1}元/㎡'
          formatter: function(params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              i === 2
                ? (relVal +=
                    "<br/>" +
                    params[i].marker +
                    params[i].seriesName +
                    ":" +
                    params[i].value +
                    " 元/㎡")
                : (relVal +=
                    "<br/>" +
                    params[i].marker +
                    params[i].seriesName +
                    ":" +
                    params[i].value +
                    " 元/㎡");
            }
            return relVal;
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: this.rentTrend.months.length != 0 ? this.rentTrend.months : pastSix,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLabel: {
            interval: 0,
            fontSize: 13,
            rotate: 30
          }
        },
        yAxis: {
          type: "value",
          boundaryGap: false,
          axisLabel: {
            interval: 0,
            fontSize: 13,
            formatter: function(value) {
              if (value >= 10000) {
                return value / 10000 + "万";
              } else if (value >= 1000 && value < 10000) {
                return value / 1000 + "千";
              } else {
                return value;
              }
            }
          },
          // x: 'center',
          splitLine: {
            lineStyle: {
              type: "dashed"
            }
          },
          data: ["0", "2千", "4千", "6千", "8千", "1万"],
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series:seriesList
      };
      if (option && typeof option === "object") {
        myChart.setOption(option, true);
      }
    },
    addMonth(date, num) {
      // num = parseInt(num);
      var sDate = this.dateToDate(date);

      var sYear = sDate.getFullYear();
      var sMonth = sDate.getMonth() + 1;
      var sDay = sDate.getDate();

      var eYear = sYear;
      var eMonth = sMonth + num;
      var eDay = sDay;
      while (eMonth > 12) {
        eYear++;
        eMonth -= 12;
      }

      var eDate = new Date(eYear, eMonth - 1, eDay);

      while (eDate.getMonth() != eMonth - 1) {
        eDay--;
        eDate = new Date(eYear, eMonth - 1, eDay);
      }

      return eDate;
    },
    dateToDate(date) {
      var sDate = new Date();
      if (typeof date == "object" && typeof new Date().getMonth == "function") {
        sDate = date;
      } else if (typeof date == "string") {
        var arr = date.split("-");
        if (arr.length == 3) {
          sDate = new Date(arr[0] + "-" + arr[1] + "-" + arr[2]);
        }
      }

      return sDate;
    }
  },
  destroyed () {
    timestampEnd = (new Date()).getTime();
    let residenceTime = timestampEnd-timestampStart;
    this.addBuried({
      source:'1',
      eventType: '页面停留时长',
      eventContent: '商圈对比停留时长'+residenceTime/1000+'s'
    });
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/area_contrast/index.vue